export const SERVICES = [
  {
    slug: "ai-ml",
    title: "AI & ML",
    icon: "BrainCircuit",
    short: "Machine learning and intelligent decision systems that move from pilot to production.",
    sub: ["Machine Learning", "Predictive Analytics", "AI Strategy", "Intelligent Decision Systems", "Computer Vision", "NLP", "AI Integration"],
    caseCategory: "AI",
  },
  {
    slug: "generative-ai",
    title: "Generative AI",
    icon: "Sparkles",
    short: "Enterprise assistants, LLM integration and retrieval systems grounded in your knowledge.",
    sub: ["Enterprise AI", "AI Assistants", "LLM Integration", "RAG", "AI Knowledge Systems", "AI Content Systems", "AI Automation"],
    caseCategory: "AI",
  },
  {
    slug: "data-engineering",
    title: "Data Engineering",
    icon: "Database",
    short: "Trusted data foundations — architecture, pipelines, warehousing and governance.",
    sub: ["Data Architecture", "Data Pipelines", "Data Warehousing", "ETL/ELT", "Data Lakes", "Analytics", "BI", "Governance"],
    caseCategory: "Data",
  },
  {
    slug: "ai-automation",
    title: "AI Automation",
    icon: "Workflow",
    short: "Automate repetitive and decision-heavy workflows with agents, RPA and document AI.",
    sub: ["Workflow Automation", "Intelligent Automation", "Process Automation", "Document Automation", "RPA", "AI Agents", "Optimization"],
    caseCategory: "Automation",
  },
  {
    slug: "cloud-ai-infrastructure",
    title: "Cloud & AI Infrastructure",
    icon: "Cloud",
    short: "Cloud architecture, migration, DevOps and secure, scalable infrastructure for AI workloads.",
    sub: ["Cloud Architecture", "Migration", "DevOps", "AI Infrastructure", "Cloud Security", "Scalability", "Monitoring"],
    caseCategory: "Cloud",
  },
  {
    slug: "custom-software",
    title: "Custom Software",
    icon: "Code2",
    short: "Web, mobile, enterprise and SaaS products — built new or modernized from legacy.",
    sub: ["Web", "Mobile", "Enterprise Software", "SaaS", "APIs", "Integration", "Product Development", "Legacy Modernization"],
    caseCategory: "Software",
  },
];

export const SERVICE_CATEGORIES = ["Advisory", "Implementation", "Migration", "Managed Services"];

export const SOLUTIONS = [
  { slug: "ai-transformation", title: "AI Transformation", intent: "Move from experimentation to practical enterprise AI.", icon: "BrainCircuit", services: ["ai-ml", "generative-ai"] },
  { slug: "digital-transformation", title: "Digital Transformation", intent: "Modernize business processes, systems and experiences.", icon: "Layers", services: ["custom-software", "ai-automation"] },
  { slug: "cloud-transformation", title: "Cloud Transformation", intent: "Migrate, modernize and optimize cloud environments.", icon: "Cloud", services: ["cloud-ai-infrastructure"] },
  { slug: "data-transformation", title: "Data Transformation", intent: "Build trusted data foundations and analytics capabilities.", icon: "Database", services: ["data-engineering"] },
  { slug: "intelligent-automation", title: "Intelligent Automation", intent: "Automate repetitive and decision-heavy workflows.", icon: "Workflow", services: ["ai-automation"] },
  { slug: "enterprise-software", title: "Enterprise Software", intent: "Build or modernize business applications.", icon: "Code2", services: ["custom-software"] },
  { slug: "workforce-transformation", title: "Workforce Solutions", intent: "Align technology, talent and workforce operations.", icon: "Users", services: [] },
  { slug: "technology-modernization", title: "Technology Modernization", intent: "Modernize legacy platforms and architectures.", icon: "RefreshCw", services: ["cloud-ai-infrastructure", "custom-software"] },
];

export const NAV_SOLUTIONS = SOLUTIONS.filter((s) => ["ai-transformation", "digital-transformation", "cloud-transformation", "data-transformation", "intelligent-automation", "workforce-transformation"].includes(s.slug));
